import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import Disclaimer from '../Disclaimer';
import { headsImageOptions } from './views/heads'

class Heads extends Component {


    render() {
		let imageOptions = headsImageOptions;

        let image = (
            <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>


					<h1><Trans defaults='Heads' /></h1>
					<p><Trans defaults='Standard heads include manual pump toilets, optional is a 12V electric, quiet flush toilet.' /></p>
					<p><Trans defaults='In this new and updated version, the tables and wash basins have been modernized to improve the overall experience.' /></p>

                    <Disclaimer />
                   

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Heads);



// WEBPACK FOOTER //
// ./src/X43MK2/Heads.js